import { LocaleClub } from '../en/club'

const club: LocaleClub = {
  clubPosts: '俱樂部貼文',
  clubs: 'Clubs',
  myClubs: '我的俱樂部',
  exploreClubs: '探索俱樂部',
  requested: '要求：',
  invited: '邀請：',
  joinClub: '加入俱樂部',
  leaveClub: '離開俱樂部',
  requestPending: '請求待定',
  invitation: '邀請',
  invitationDesc: '您受到俱樂部總監的邀請，您想加入這個俱樂部嗎？',
  acceptInvitation: '您現在是受邀俱樂部的成員。',
  declineInvitation: '您拒絕成為受邀俱樂部的會員。',
  editClub: '編輯俱樂部',
  fixClubPayments: '解决俱樂部帳戶付款問題',
  setUpYourClubPayments: '設定您的俱樂部付款以創建比賽',
  about: '關於',
  clubDetails: '俱樂部詳情',
  clubContact: '俱樂部連絡人',
  clubAbout: '關於俱樂部',
  directors: '董事',
  organizers: '組織者',
  invitePlayers: '邀請會員',
  importPlayersCSV: '通過CSV導入會員',
  removeMember: '移除會員',
  removeMemberDesc: '該成員將被俱樂部删除',
  playerAddedSuccess: '選手添加成功',
  importPlayers: '導入選手',
  importMatchesCSV: '通過CSV導入比賽',
  importMatches: '倒入比賽',
  createNewEvent: '創建新比賽',
  eventDetails: '比賽詳情',
  addOrganizers: '添加組織者',
  clubOrganizers: '俱樂部組織者必須有一個個人DUPR帳戶才能添加到您的俱樂部。',
  clubPlayers: '俱樂部會員必須有一個個人DUPR帳號才能加入您的俱樂部',
  addOrganizer: '添加組織者',
  addMember: '添加會員',
  inviteAPLayer: '邀請會員',
  inviteAPLayerDesc: '被邀請的會員必須使用下麵的電子郵件創建一個帳戶，比賽結果才能生效',
  clubName: '俱樂部名稱',
  removeOrganizerTitle: '刪除俱樂部組織者',
  removeOrganizerText: '您確定要刪除此帳戶作為組織者的身分嗎？',
  removeOrganizer: '確認',
  createEventDesc: '註冊和組織隊伍不可用，因為我們目前正在努力將您與我們的 API 合作夥伴連結起來。',
  seedMatchesDesc:
    '組織隊伍不再可用。我們希望推廣我們的活動管理 API 合作夥伴，您現在可以在 [註冊] 按鈕上貼上來自其他軟體的活動 URL',
  leaveDUPRWarning: '點擊此按鈕後，您將被重新導向到註冊頁面並離開此 DUPR 頁面。',
  clubsNearMe: '我附近的俱樂部',
}

export default club
